// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overview-spinner {
  position: absolute;
  margin: 0 auto !important;
  top: 10% !important;
  left: 45% !important;
}

.hover-opacity-100:hover {
  opacity: 1 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/claims-app/user-overview/user-overview.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,oBAAA;AACJ;;AAEA;EACI,qBAAA;AACJ","sourcesContent":[".overview-spinner {\r\n    position: absolute;    \r\n    margin: 0 auto !important;\r\n    top:10% !important;\r\n    left:45% !important;\r\n}\r\n\r\n.hover-opacity-100:hover {\r\n    opacity: 1 !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
